import Cookies from 'js-cookie';
import React, { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import ChooseBackground from '../../functions/chooseBackground';
import CookieFunction from '../../functions/cookieFunction';
import backgrounds from '../../objects/backgrounds';
import BackgroundProgressBar from '../BackgroundProgressBar';
import ChatDemo from '../ChatDemo';
// import { AdminContext } from '../../../context/AdminContext';
import Checkbox from '../CheckBox';
import styles from './styles.module.scss';
// import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';

const BackgroundBox = ({
  onClickLang = () => console.log('theme'),
  extraClassName = 'nothing',
}) => {
  const {
    themeColor,
    direction,
    setDirection,
    content,
    setContent,
    bg,
    setBg,
    themeMode,
  } = useContext(AdminContext);
  const [activeBg, setActiveBg] = useState(bg);

  const changeActiveBg = (x) => {
    CookieFunction('set', 'ochattBg', x, () => {
      setBg(CookieFunction('get', 'ochattBg'));
      setActiveBg(CookieFunction('get', 'ochattBg'));
    });
  };

  console.log('languageArray', backgrounds, activeBg);
  return (
    <div className={` noBorder w-full h-full`}>
      <div
        className={`flex flex-row w-full justify-start items-start w-full h-auto ${extraClassName} ${styles.boxContainer} themeContainer`}
      >
        {backgrounds?.values?.map((item, index) => (
          <div
            className={`flex flex-row justify-start items-center  cursor-pointer ${
              styles.itemBox
            } ${
              bg == item?.id
                ? ` ${styles.activeColor} activeThemeBorder`
                : ` ${styles.unActive} `
            }`}
            onClick={() => {
              changeActiveBg(item?.id);
            }}
            key={index}
            style={{
              // backgroundImage: `url(../../../../../assets/imgs/backgrounds/pattern_${bg}.png)`,
              backgroundImage: `url(${ChooseBackground(item?.id)?.src})`,
            }}
          >
            {/* <div className={`${styles.color} bg-white-theme `}></div>
            <div className={`mx-8px ${themeColor != 'white' && 'textWhite'}`}>
              {item?.id}
            </div> */}
          </div>
        ))}
      </div>
      {!ChooseBackground(bg)?.cover && (
        <BackgroundProgressBar
          content={content}
          extraClassName={`e-rangeBack`}
        />
      )}
      <div
        className={`message__container ${styles.demo} ${
          themeMode != 'dark'
            ? 'message__containerScrollbarW'
            : 'message__containerScrollbarD'
        } messageContainerShadow`}
      >
        <ChatDemo content={content} />
      </div>
    </div>
  );
};

export default BackgroundBox;
